import { colors } from '@dixa/lib-shared-tokens';
import type { ConversationStatus } from 'lib-shared-types-api';

/** Represents various conversation status attributes. */
export const conversationStatusAttributes: Record<
  ConversationStatus,
  {
    /** The pretty name of the status. */
    readonly label: string;
    /** The color of the status. */
    readonly color: string;
  }
> = {
  open: { label: 'Open', color: colors.green['500'] },
  closed: { label: 'Closed', color: colors.neutral['500'] },
  pending: { label: 'Follow-up', color: colors.neutral['500'] },
  awaitingpending: { label: 'Follow-up', color: colors.blue['500'] },
};
